import SmoothScroll from 'smooth-scroll';
import Gumshoe from 'gumshoejs';

const smoothScroll = () => {
  // eslint-disable-next-line no-unused-vars
  const scroll = new SmoothScroll('a[href*="#"][data-scroll]', {
    speed: 500,
    updateURL: true,
    clip: true,
    offset(anchor, toggle) {
      if (toggle.classList.contains('c-anchor-nav__btn')) {
        return 170;
      }
      return 10;
    },
  });
};

const scrollTop = () => {
  const btn = document.querySelector('.b-scrolltop');
  if (btn) {
    const y = window.scrollY;
    if (y >= 2000) {
      btn.classList.remove('hidden');
    } else {
      btn.classList.add('hidden');
    }
  }
};
window.addEventListener('scroll', scrollTop);
smoothScroll();

const scrollSpy = () => {
  const scrollspyElm = document.querySelector('.c-anchor-nav');
  if (scrollspyElm) {
    // eslint-disable-next-line no-new
    new Gumshoe('.c-anchor-nav a', {
      navClass: 'active',
      offset: 150,
    });
  }
};

scrollSpy();
